import { IconInfo } from '@heathmont/moon-assets';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import useSite from '~/client/hooks/useSite';
import InlineStack from '~/client/shared/InlineStack';
import media from '~/client/shared/media';

const InfoContainer: FC = ({ children }) => {
  const { isSportsbet } = useSite();
  return (
    <InfoBlock isSportsbet={isSportsbet}>
      <InlineStack templateColumns="max-content">
        <About fontSize={18} />
        {children}
      </InlineStack>
    </InfoBlock>
  );
};

type InfoBlockProps = {
  isSportsbet?: boolean;
  children: React.ReactNode;
};

const InfoBlock = styled.div<InfoBlockProps>`
  background-color: ${({ theme, isSportsbet }) =>
    isSportsbet ? theme.color.goku[100] : theme.color.gohan[100]};
  border-radius: ${({ theme }) => rem(theme.radius.default)};
  padding: ${rem(14)};
  ${media.desktopSmall} {
    padding: ${({ theme }) => rem(theme.space.medium)};
  }
`;

const About = styled(IconInfo)`
  && {
    background-color: ${({ theme }) => theme.color.whis[100]};
    color: ${({ theme }) => theme.color.gohan[100]};
    border-radius: 50%;
    padding: ${rem(4)};
    margin-top: ${rem(6)};
    ${media.desktopSmall} {
      margin-top: 0;
      align-self: center;
    }
  }
`;

export default InfoContainer;
